import React from 'react';
import Checkbox from 'material-ui/Checkbox'
import styles from './styles';
import { FormGroup, FormControlLabel } from 'material-ui/Form';

const renderCheckbox = ({ input, label }) => (
   <FormGroup row>
      <FormControlLabel
          control={
            <Checkbox
            checked={input.value ? true : false}
            onChange={input.onChange}
          />
          }
          label={label}
        />
    
  </FormGroup>  
)

export default renderCheckbox;


// WEBPACK FOOTER //
// ./src/components/MaterialUi/renderCheckbox.js